// ActionTypes
const ActionTypes = {
  SET_MATCHING_QUESTIONS_RESPONSE: "SET_MATCHING_QUESTIONS_RESPONSE",
};

// Action creators
const setMatchingQuestionResponse = (data) => ({
  type: ActionTypes.SET_MATCHING_QUESTIONS_RESPONSE,
  payload: data,
});

// Export the ActionTypes and action creators
export { ActionTypes, setMatchingQuestionResponse };
